import React, { CSSProperties, ReactNode } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import moment from 'moment';
import { useDates } from '@vivli/shared/infrastructure/hook';

const containerStyle: CSSProperties = {
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: '10px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};

interface GridCellDateComponentProps extends ICellRendererParams {}

export const GridCellDateView = ({ value }: GridCellDateComponentProps): ReactNode => {
    const { formatDate } = useDates();
    const formattedDate = value && formatDate(value);
    return (
        <div style={containerStyle} className="scrolly">
            {formattedDate}
        </div>
    );
};
